<ng-container>
  <c-container [fluid]="true" class="px-4 app-header">
    <c-header-nav class="d-none d-md-flex ms-auto gap-3 me-4">
      <button 
      (click)="emitLogoutClick()"
      type="button" class="icon-btn p-0 text-body">
        <svg cIcon name="cilAccountLogout" size="lg"></svg>
      </button>
    </c-header-nav>
  </c-container>
</ng-container>